import { useCallback, useEffect, useMemo, useState } from 'react';
import { CommentsMode } from '../../../modules/types/comments';
import { getListData } from '../data';

interface IParams {
  isOpen: boolean;
  closeCallback: () => void;
  confirmCallback: (mode: CommentsMode) => void;
}

export const useDisableCommentsModal = ({ isOpen, closeCallback, confirmCallback }: IParams) => {
  const [activeRadio, setActiveRadio] = useState<CommentsMode | ''>('');

  // Translations are read at call time, so build the list once per open rather
  // than on every keystroke-triggered re-render.
  const listData = useMemo(() => getListData(), []);

  useEffect(() => {
    if (isOpen) {
      setActiveRadio('');
    }
  }, [isOpen]);

  const selectMode = useCallback((mode: CommentsMode) => setActiveRadio(mode), []);

  const confirm = useCallback(() => {
    if (!activeRadio) return;

    confirmCallback(activeRadio);
    closeCallback();
  }, [activeRadio, confirmCallback, closeCallback]);

  return { activeRadio, listData, selectMode, confirm, isConfirmDisabled: !activeRadio };
};
